import { render, staticRenderFns } from "./addOrgToProduct.vue?vue&type=template&id=5d76be26&"
import script from "./addOrgToProduct.vue?vue&type=script&lang=ts&"
export * from "./addOrgToProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports